var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"rootElement",staticClass:"zoom-toggle-container-component"},[_c('div',{on:{"click":_setup.handleRegularClick,"dragstart":function($event){$event.preventDefault();}}},[_vm._t("regular")],2),_c(_setup.PannableViewport,{ref:"zoomedElement",staticClass:"zoom-toggle-container-component-zoomed",style:({
                          opacity: _setup.isZoomed ? '1' : '0',
                          'pointer-events': _setup.isZoomed ? 'auto' : 'none',
                      }),on:{"click":_setup.handleZoomedClick}},[_vm._t("zoomed")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }